var _style, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExploreStaking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0,.st1,.st2,.st3,.st4,.st5{fill:none;stroke:#fff;stroke-width:6;stroke-linecap:round}.st1{clip-path:url(#SVGID_00000014625649746893865940000012649191935905429142_)}.st2{clip-path:url(#SVGID_00000170999166213222837410000017475137191368005813_)}.st3{clip-path:url(#SVGID_00000012444202410738623220000017911886846604630183_)}.st4{clip-path:url(#SVGID_00000106121007130906558580000009718441011319570568_)}.st5{clip-path:url(#SVGID_00000172432565111891740480000004081201832880615084_)}.st6,.st7{clip-path:url(#SVGID_00000099638863782045463030000006963943482090181014_)}.st6{fill:none;stroke:#fff;stroke-width:6;stroke-linecap:round}.st7{fill:#16171c}.st8,.st9{clip-path:url(#SVGID_00000066484615359842437060000013608760301307328935_)}.st8{fill:none;stroke:#fff;stroke-width:6;stroke-linecap:round}.st9{fill:#fff}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000096030740300383136800000005343743253471933577_",
    d: "M7 15.9h85.5V85H7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129917646123307512910000006096383900199382712_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096030740300383136800000005343743253471933577_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129917646123307512910000006096383900199382712_)",
      fill: "none",
      stroke: "#fff",
      strokeWidth: 6,
      strokeLinecap: "round"
    },
    d: "M33.4 19.3h-2.2c-1.2 0-2.5.1-3.6.3M27 81.1c1.3.3 2.7.4 4.2.4h20.7c11.5 0 20.7-9.3 20.7-20.7V40.1c0-11.5-9.3-20.7-20.7-20.7H33.4m-5.9.3c-9.7 1.7-17.1 10.2-17.1 20.4v20.7c0 10 7.1 18.4 16.6 20.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129917646123307512910000006096383900199382712_)",
      fill: "#16171c"
    },
    d: "M47.6 19.3c-11.5 0-20.7 9.3-20.7 20.7v20.7c0 11.5 9.3 20.7 20.7 20.7h20.7c11.5 0 20.7-9.3 20.7-20.7V40.1c0-11.5-9.3-20.7-20.7-20.7H47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129917646123307512910000006096383900199382712_)",
      fill: "none",
      stroke: "#fff",
      strokeWidth: 6,
      strokeLinecap: "round"
    },
    d: "M47.6 19.3c-11.5 0-20.7 9.3-20.7 20.7v20.7c0 11.5 9.3 20.7 20.7 20.7h20.7c11.5 0 20.7-9.3 20.7-20.7V40.1c0-11.5-9.3-20.7-20.7-20.7H47.6z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreStaking);
export default __webpack_public_path__ + "static/media/exploreStaking.fd510f9d788f2a9351906474ad8ca387.svg";
export { ForwardRef as ReactComponent };